import { timeZoneOptions } from 'common/utils/fixed';
import { strToNumber } from 'common/utils/numbers';

export const initializeTimezone = timezone => {
  return (
    timeZoneOptions.find(option => option.label === timezone) ||
    timeZoneOptions.find(option => option.id == strToNumber(timezone)) ||
    timezone
  );
};

export const getPortSize = (options = [], size, showName = false) => {
  const selected = options?.find(f => f?.label === size);
  return showName ? selected?.name || '-' : selected;
};
